import React from 'react';
import Head from 'next/head';
import { ContentProps } from 'types/content-props/_content-common';
import { generateJsonLd } from './json-ld-generator';
import { getContentTypeToStructure } from './helpers/thingHelpers';

interface JsonLdScriptProps {
    content: ContentProps;
}

export const StructuredData: React.FC<JsonLdScriptProps> = ({ content }) => {
    if (!getContentTypeToStructure(content)) {
        return null;
    }

    const jsonLdData = generateJsonLd(content);

    const shouldPrettyJson = process.env.ENV !== 'prod';

    return (
        <Head>
            <script
                type="application/ld+json"
                dangerouslySetInnerHTML={{
                    __html: JSON.stringify(jsonLdData, null, shouldPrettyJson ? 2 : 0),
                }}
            />
        </Head>
    );
};
